import React from 'react';
import Wave from 'react-wavify';
import './WaveContainer.css';

function getH() {
    return (window.innerHeight / 10)}

function getA() {
    return (window.innerHeight / 10) }

function WaveContainer(props = {
    wid: 'wave', fill: '#FFFFFF', paused: false, speed: 0.35, points: 5 }) {

    return (
        <div id={props.wid} className={'wave-container'}>
            <Wave className={"wave-header"}
              fill={props.fill}
              paused={props.paused}
              options={{
                  height: getH(),
                  amplitude: getA(),
                  speed: props.speed,
                  points: props.points,
              }}
            />
            <section className={"wave-body"}>
                {props.children}
            </section>
        </div>
    );
}

export default WaveContainer;
